import { AIService } from '../services/ai.service.js';
import { stateManager } from '../services/state.js';
import { authManager } from '../services/auth.js';

export class AIChatUI {
    constructor() {
        this.sessionId = "session_" + Date.now();
        this.isOpen = false;
        this.renderFAB();
        this.renderPanel();
        this.bindEvents();
    }

    renderFAB() {
        this.fab = document.createElement('button');
        this.fab.innerHTML = `<span style="font-family:'Inter',sans-serif;font-weight:bold;font-size:15px;letter-spacing:0.5px;color:#2F556F;">ArberIA</span>`;
        this.fab.style.cssText = `
            position: fixed;
            bottom: 80px;
            right: 20px;
            width: auto; padding: 0 20px;
            height: 48px;
            border-radius: 24px;
            background: linear-gradient(135deg, #ffffff 0%, #e8ecf1 50%, #d1d6dc 100%);
            box-shadow: 0 4px 15px rgba(0,0,0,0.15);
            border: none;
            cursor: pointer;
            z-index: 9999;
            display: none;
            align-items: center;
            justify-content: center;
            transition: transform 0.3s ease;
        `;
        document.body.appendChild(this.fab);
        
        this.checkVisibility = () => {
            const rawPath = window.location.pathname.substring(1);
            const path = (rawPath === '' || rawPath === 'landing') ? 'login' : rawPath;
            const hash = window.location.hash || '';
            const isAuth = stateManager.isAuthenticated() || authManager.isAuthenticated;
            
            // Nascondi SEMPRE nella pagina di login, landing, admin-login o se non si è loggati
            const isLoginPage = path === 'login' || path === 'landing' || path === 'admin-login' || hash.includes('login') || hash.includes('landing');
            
            if (!isAuth || isLoginPage) {
                this.fab.style.display = 'none';
                if (this.panel) {
                    this.panel.style.display = 'none';
                    if (this.isOpen) this.toggle();
                }
            } else {
                this.fab.style.display = 'flex';
                if (this.panel) {
                    this.panel.style.display = 'flex';
                }
            }
        };
        
        this.checkVisibility();
        window.addEventListener('hashchange', this.checkVisibility);
        window.addEventListener('popstate', () => setTimeout(this.checkVisibility, 50));
        window.addEventListener('navigate', () => setTimeout(this.checkVisibility, 50));
        setInterval(this.checkVisibility, 400);
    }

    renderPanel() {
        this.panel = document.createElement('div');
        this.panel.style.cssText = `
            position: fixed;
            bottom: 150px;
            right: 20px;
            width: 350px;
            height: 500px;
            max-width: 90vw;
            max-height: 70vh;
            background: rgba(255, 255, 255, 0.85);
            backdrop-filter: blur(15px);
            -webkit-backdrop-filter: blur(15px);
            border-radius: 20px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
            border: 1px solid rgba(255,255,255,0.4);
            z-index: 9998;
            display: none;
            flex-direction: column;
            overflow: hidden;
            transform: translateY(20px) scale(0.95);
            opacity: 0;
            pointer-events: none;
            transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        `;

        this.panel.innerHTML = `
            <div style="background: linear-gradient(135deg, #ffffff 0%, #e8ecf1 50%, #d1d6dc 100%); padding: 15px; color: white; font-weight: bold; display: flex; justify-content: space-between; align-items: center;">
                <span style="color: black;">ArberIA Assistant</span>
                <button id="arberia-close-chat" style="background:none;border:none;color:white;font-size:20px;cursor:pointer;">&times;</button>
            </div>
            <div id="arberia-chat-messages" style="flex:1; padding: 15px; overflow-y: auto; display: flex; flex-direction: column; gap: 10px; font-size: 14px;">
                <div style="background: #e2e8f0; padding: 10px 15px; border-radius: 15px 15px 15px 4px; max-width: 80%; align-self: flex-start;">
                    Mirë se erdhe! Sono ArberIA, la tua guida digitale. Come posso aiutarti a scoprire il territorio?
                </div>
            </div>
            <div style="padding: 10px; border-top: 1px solid rgba(0,0,0,0.1); display: flex; gap: 8px;">
                <input type="text" id="arberia-chat-input" placeholder="Scrivi un messaggio..." style="flex: 1; padding: 10px 15px; border-radius: 20px; border: 1px solid #ccc; outline: none;" />
                <button id="arberia-chat-send" style="background: #1e3c72; color: white; border: none; padding: 0 15px; border-radius: 20px; cursor: pointer;">Invia</button>
            </div>
        `;
        document.body.appendChild(this.panel);

        this.messagesContainer = this.panel.querySelector('#arberia-chat-messages');
        this.input = this.panel.querySelector('#arberia-chat-input');
        this.sendBtn = this.panel.querySelector('#arberia-chat-send');
        this.closeBtn = this.panel.querySelector('#arberia-close-chat');
    }

    bindEvents() {
        this.fab.addEventListener('click', () => this.toggle());
        this.closeBtn.addEventListener('click', () => this.toggle());
        
        this.sendBtn.addEventListener('click', () => this.handleSend());
        this.input.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') this.handleSend();
        });
    }

    toggle() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.panel.style.transform = 'translateY(0) scale(1)';
            this.panel.style.opacity = '1';
            this.panel.style.pointerEvents = 'auto';
            this.input.focus();
        } else {
            this.panel.style.transform = 'translateY(20px) scale(0.95)';
            this.panel.style.opacity = '0';
            this.panel.style.pointerEvents = 'none';
        }
    }

    appendMessage(text, isUser = false) {
        const div = document.createElement('div');
        div.style.cssText = isUser
            ? `background: #1e3c72; color: white; padding: 10px 15px; border-radius: 15px 15px 4px 15px; max-width: 80%; align-self: flex-end; white-space: pre-wrap;`
            : `background: #e2e8f0; color: #333; padding: 10px 15px; border-radius: 15px 15px 15px 4px; max-width: 80%; align-self: flex-start; white-space: pre-wrap;`;
        div.textContent = text;
        this.messagesContainer.appendChild(div);
        this.messagesContainer.scrollTop = this.messagesContainer.scrollHeight;
    }

    async handleSend() {
        const text = this.input.value.trim();
        if (!text) return;

        this.appendMessage(text, true);
        this.input.value = '';

        const typingDiv = document.createElement('div');
        typingDiv.textContent = 'ArberIA sta pensando...';
        typingDiv.style.cssText = `font-size: 12px; color: #666; margin-left: 5px;`;
        this.messagesContainer.appendChild(typingDiv);

        try {
            // Ottieni posizione se possibile
            let gps = null;
            
            const res = await AIService.sendMessage(text, gps, this.sessionId);
            this.messagesContainer.removeChild(typingDiv);
            
            this.appendMessage(res.answer, false);
            
            if (res.actions && res.actions.length > 0) {
                this.executeActions(res.actions);
            }
        } catch (err) {
            console.error('[AIChat Error Caught]:', err);
            this.messagesContainer.removeChild(typingDiv);
            this.appendMessage("Scusami, ho un vuoto di memoria in questo momento. Riprova tra poco!", false);
        }
    }

    executeActions(actions) {
        actions.forEach(action => {
            if (action.type === 'SHOW_POI' && action.payload?.poiId) {
                // Generiamo un evento custom che il main.js o il map.js possono intercettare
                window.dispatchEvent(new CustomEvent('arberia-ai-action', { detail: action }));
            }
        });
    }
}
